import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CacheLoaderService } from './cache-loader.service';
import { ProjectStatus } from '@/models/project-status.model';
import { DraftStatus } from '@/models/binder.model';

@Injectable({
  providedIn: 'root'
})
export class StatusesService {
  private BASE_URL = environment.landmark_API_URL;

  projectStatusData = signal<ProjectStatus[]>([]);
  draftStatusData = signal<DraftStatus[]>([]);

  constructor(
    private http: HttpClient,
    private projectStatusLoader: CacheLoaderService<ProjectStatus>,
    private draftStatusLoader: CacheLoaderService<DraftStatus>
  ) { 
    this.loadProjectStatuses();
    this.loadDraftStatuses();
  }

  loadProjectStatuses(): void {
    this.projectStatusLoader.loadData('statuses/project', (projectStatuses) => {
      this.projectStatusData.set(projectStatuses);
    }, 'projectStatusesCacheKey');
  }

  loadDraftStatuses(): void {
    this.draftStatusLoader.loadData('statuses/drafting', (draftStatuses) => {
      this.draftStatusData.set(draftStatuses);
    }, 'draftStatusesCacheKey');
  }
}